
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-08-03-edges-geometry",
      function () {
        return require("private-next-pages/blogs/2025-08-03-edges-geometry/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-08-03-edges-geometry"])
      });
    }
  